import React from 'react';
import styles from './logs.module.scss';
import convertDateTime from './convert';
import ActionRow from './actionRow';

export default function ErrorRow({ item }) {
  const [show, setShow] = React.useState(false);

  return (
    <li className={styles.row}>
      <div className={styles.row__header}>
        <time className={styles.header__time} dateTime={item.timestamp}>
          {convertDateTime(item.timestamp)}
        </time>
        <span className={styles.header__tag}>{item.tag}</span>
        <span className={styles.header__message}>{item.error.message}</span>
        <div className={styles.row__divider} />
        <button
          onClick={() => setShow(!show)}
          className={styles.header__button}
        >
          <span>{show ? 'hide' : 'show'}</span>
        </button>
      </div>

      {show && (
        <div className={styles.row__content}>
          <span className={styles.content__header}>Message</span>
          <span className="message">{item.error.message}</span>

          {item.actions && (
            <>
              <span className={styles.content__header}>Actions</span>
              <ul>
                {item.actions.map((c, i) => (
                  <ActionRow key={i} item={c} />
                ))}
              </ul>
            </>
          )}
          {item.metadata && (
            <>
              <span className={styles.content__header}>Metadata</span>
              <pre className="language-js">
                <code>{JSON.stringify(item.metadata, null, '\t')}</code>
              </pre>
            </>
          )}
          {item.error.stack && (
            <span className={styles.content__header}>Stacktrace</span>
          )}
          {item.error.stack && (
            <pre className="language-js">
              <code>
                {item.error.stack.split('\r\n').map((c, i) => (
                  <span key={i}>{c}</span>
                ))}
              </code>
            </pre>
          )}
        </div>
      )}
    </li>
  );
}
